import * as yup from 'yup';

export const updatePayoffSchema = yup.object().shape({
  eta: yup.string().nullable(),
});

export const updateTaxCertificationSchema = yup.object().shape({
  eta: yup.string().nullable(),
});
